var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInnovation02 = function SvgInnovation02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "innovation-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#innovation-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.385 13.482a1.977 1.977 0 1 0 0-3.953 1.977 1.977 0 0 0 0 3.953ZM10.358 13.955a4.673 4.673 0 0 0-4.674 4.674h9.348a4.673 4.673 0 0 0-4.674-4.674ZM15.143 6.13c-.481 0-.916.195-1.23.51a1.736 1.736 0 0 0-.324 2.016c.123.244.303.456.523.618a.765.765 0 0 1 .317.624v.621h1.429v-.621a.761.761 0 0 1 .317-.624 1.739 1.739 0 0 0 .2-2.633 1.739 1.739 0 0 0-1.232-.51ZM14.374 10.706c0 .42.348.766.768.766.42 0 .768-.347.768-.768h-.768l-.768.002ZM17.282 8.05l-.042.297 1.053.152.043-.297-1.054-.151ZM17.994 6.426l-.968.442.125.273.968-.442-.125-.273ZM16.747 5.118l-.575.895.252.162L17 5.28l-.252-.162ZM15.29 4.69h-.3v1.065h.3V4.691ZM13.534 5.119l-.252.162.575.895.253-.162-.576-.895ZM12.288 6.432l-.124.272.968.443.124-.273-.968-.442ZM13.001 8.056l-1.053.151.042.297 1.054-.151-.043-.297Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "innovation-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgInnovation02 as ReactComponent };